/// <reference path="../../common/common.module.ts" />

/**
 * Build Version Service
 *
 * Single source for the static-asset cache-busting token.
 *
 * The build pipeline stamps every four-part version literal in Home.cshtml
 * with $(MeevoBuildNumber) (see the "Update Version: Home.cshtml" task), so
 * window.MeevoBuildVersion arrives already set to the deployed build. Keying
 * ?v= on it means a browser re-downloads an asset only when the build that
 * produced it changed — a page refresh serves it from disk cache instead of
 * re-fetching, which a per-request timestamp can never do.
 *
 * When the value is absent or still the un-stamped placeholder, we fall back
 * to a timestamp captured ONCE at construction. Two cases hit that path and
 * both need it: localhost is never stamped at all, and the pipeline task is
 * skipped for pull-request builds. Caching by placeholder there would pin
 * developers to whichever bundle their browser saw first.
 *
 * Usage:
 *   buildVersion.append('/lib/meevo-foo.js')  → '/lib/meevo-foo.js?v=2.2026.08.52138'
 */

const BUILD_VERSION_PLACEHOLDER = '1.0.0.0';

angular.module('meevo.components.common').factory('buildVersion', [
    function () {
        var stamped = (window as any)['MeevoBuildVersion'];
        var isStamped = typeof stamped === 'string' &&
            stamped.length > 0 &&
            stamped !== BUILD_VERSION_PLACEHOLDER;

        // Resolved once per page load, never per call — a token that changed
        // between calls would defeat the browser cache it exists to populate.
        var token = isStamped ? stamped : String(new Date().getTime());

        if (!isStamped) {
            console.log('[buildVersion] No stamped build number — using a per-session token. ' +
                'Expected on localhost and pull-request builds.');
        }

        return {
            /** The cache-busting token: the deployed build number, or a per-session fallback. */
            token: function (): string {
                return token;
            },

            /** True when the token came from the pipeline rather than the fallback. */
            isStamped: function (): boolean {
                return isStamped;
            },

            /** Append ?v=<token> to a URL, preserving any query string it already carries. */
            append: function (url: string): string {
                if (!url) { return url; }
                var separator = url.indexOf('?') >= 0 ? '&' : '?';
                return url + separator + 'v=' + encodeURIComponent(token);
            },
        };
    }
]);
